import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
    openSubMenu,
    closeSubMenu,
} from "../../contents/redux/actions/subMenuActions";
import { ArrowDropDownRounded } from "@mui/icons-material";
import styles from "../utilities/cssmodules/Sidebar.module.css";

const MenuLinkItem = ({ id, icon, label, to, subMenu, toggleSidebar }) => {
    const dispatch = useDispatch();
    const openSubMenuId = useSelector((state) => state.subMenu.openSubMenuId);

    // Debug: Log when this item is rendered
    console.log(`Rendering MenuLinkItem: ${label} (ID: ${id})`);

    const handleToggleSubMenu = (e) => {
        e.stopPropagation();
        console.log(`Toggling submenu for ${label} (ID: ${id})`);
        if (openSubMenuId === id) {
            dispatch(closeSubMenu());
        } else {
            dispatch(openSubMenu(id));
        }
    };

    const handleLinkClick = () => {
        console.log(`Navigating via ${label} (ID: ${id})`);
        if (toggleSidebar) {
            toggleSidebar(); // Close sidebar on mobile
        }
    };

    const getMenuDataAttributes = () => {
        if (label === "System Management")
            return { "data-tour": "system-management" };
        if (label === "User Management") return { "data-tour": "user-management" };
        if (label === "Settings") return { "data-tour": "settings-menu" };
        if (label === "Department Management")
            return { "data-tour": "dept-management" };
        return {};
    };

    return (
        <div className={styles["menu-link"]} {...getMenuDataAttributes()}>
            {to ? (
                <NavLink
                    to={to}
                    className={({ isActive }) => (isActive ? styles["active"] : "")}
                    onClick={handleLinkClick}
                >
                    <span className={styles["menu-icon"]}>{icon}</span>
                    <span className={styles["menu-label"]}>{label}</span>
                </NavLink>
            ) : (
                <div
                    className={styles["dropdown-menu-label"]}
                    onClick={handleToggleSubMenu}
                    data-submenu-id={id}
                >
                    <span className={styles["menu-icon"]}>{icon}</span>
                    <span className={styles["menu-label"]}>{label}</span>
                    <span className={styles["dropdown-menu-label-icon"]}>
                        <ArrowDropDownRounded />
                    </span>
                </div>
            )}
            {subMenu && openSubMenuId === id && (
                <div
                    className={`${styles.submenu} ${openSubMenuId === id ? styles.show : ""}`}
                >
                    {subMenu.map((subMenuItem) => (
                        <NavLink
                            key={subMenuItem.id}
                            to={subMenuItem.path}
                            className={({ isActive }) =>
                                isActive ? styles["active-submenu-item"] : ""
                            }
                            data-testid={`${subMenuItem.permissionCategoryName.toLowerCase().replace(" ", "-")}-link`}
                            onClick={handleLinkClick}
                        >
                            <span className={styles["submenu-icon"]}>{subMenuItem.icon}</span>
                            <span className={styles["submenu-label"]}>
                                {subMenuItem.permissionCategoryName}
                            </span>
                        </NavLink>
                    ))}
                </div>
            )}
        </div>
    );
};

export default React.memo(MenuLinkItem);
